import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.css']
})
export class ColumnComponent {
  @Input() sortable = false;
  @Input() defaultSorting = false;
  @Input() title: string;
  @Input() icon: string;
  @Input() property: string;
  @Input() type = 'string';
  @Input() width: string;
  @Input() minWidth: string;
  @Input() iconColumn: (value: any) => string = null;
  @Input() transformation: (value: any) => string;
  @Input() tooltip: (value: any) => string;
  @Input() imageUrl: (value: any) => string;
  @Input() linkable = false;
  @Input() styleColumn: (value: any) => string = null;
  @Input() styleTh = '';
  /**
   * When true, holding the mouse on the cell for `longPressMillis` triggers
   * `longPressed` instead of `clicked`. The regular click handler still fires
   * for short clicks. Used by the planner OF column to expose the
   * "mark as urgent" modal without a dedicated icon.
   */
  @Input() longPressable = false;
  @Input() longPressMillis = 500;
  @Output() clicked = new EventEmitter<any>();
  @Output() longPressed = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/sortable-table/column/column.component.ts